// extracted by mini-css-extract-plugin
module.exports = {"error-container":"ErrorWrapper_error-container__3aM3S"};